export default function Copyright() {
  return (
    <p className="text-sm text-gray-500">
      &copy; 2020 Asociación Iberoamericana de Scrum
    </p>
  );
}
